/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import axios from 'axios';
import { StatusService } from '../services';
import { GlobalStatus, IStatus, WorkerStatus } from '../types';
import { useGlobalState } from '../contexts/GlobalStateContext';

interface Props {
  defaultValue?: WorkerStatus;
  deps?: any[];
  withServiceConnection?: boolean;
}

export const useStatus = ({
  defaultValue = 'idle',
  deps = [],
  withServiceConnection = false,
}: Props): {
  workerStatus: WorkerStatus;
  globalStatus: GlobalStatus | undefined;
  error: boolean;
} => {
  const [workerStatus, setWorkerStatus] = React.useState<WorkerStatus>(defaultValue);
  const [globalStatus, setGlobalStatus] = React.useState<GlobalStatus | undefined>(undefined);
  const { setStatus } = useGlobalState();
  // const [loadingStatus, setLoadingStatus] = React.useState<boolean>(false);

  const [error, setError] = React.useState<boolean>(false);

  React.useEffect(() => {
    const request = axios.CancelToken.source();

    const fetchWorkerStatus = async () => {
      if (error) {
        setError(false);
      }

      try {
        const status: IStatus = await StatusService.getStatus(request, withServiceConnection);
        setStatus(status);
        setWorkerStatus(status.worker);
        setGlobalStatus(status.global);
      } catch (error) {
        if (axios.isCancel(error)) {
          console.debug('Request was cancelled');
        } else {
          setError(true);
        }
      }
    };

    fetchWorkerStatus();

    return () => request.cancel();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps]);

  return { workerStatus, globalStatus, error };
};
